import { ExclamationCircleFilled, UserOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';
import { Col } from 'antd';
import { Account } from 'src/models';
import { Color } from 'src/styles';

import { MTypography } from '../MTypography/MTypography';

import { AccountHolderFullName } from './AccountHolderFullName';
import { MenuItem } from './MenuItem';

const baseStyle = (lastFailedLinkAccountError?: string) =>
  css({
    background: lastFailedLinkAccountError ? Color.Orange1 : undefined,
  });

interface AccountMenuItemProps {
  account?: Account;
  isLoading?: boolean;
  onClick: () => void;
}

export const AccountMenuItem = ({ account, isLoading, onClick }: AccountMenuItemProps) => {
  return (
    <MenuItem
      name={
        <>
          <AccountHolderFullName account={account} alignment={'start'} compact />
          <Col>
            {account?.lastFailedLinkAttemptError && (
              <MTypography variant='body1' color={Color.Orange6}>
                Linking Error
              </MTypography>
            )}
          </Col>
        </>
      }
      startIcon={<UserOutlined style={{ fontSize: 24 }} />}
      endIcon={
        account?.lastFailedLinkAttemptError ? (
          <ExclamationCircleFilled style={{ fontSize: '24px', color: Color.Orange6 }} />
        ) : undefined
      }
      isLoading={isLoading}
      onClick={isLoading ? undefined : onClick}
      className={baseStyle(account?.lastFailedLinkAttemptAt)}
    />
  );
};
